/** Weekwise tab: single chart selection narrows all widgets (same idea as Monthwise / Count & Time drill). */
export type UsersChartDrill =
  | null
  /** weekStart: UTC Monday YYYY-MM-DD (ISO week start; matches activityByWeek). */
  | { kind: 'week'; weekStart: string }
  | { kind: 'activityType'; activityType: string }
  | { kind: 'customer'; customerId: string };

export function usersChartDrillQueryKey(d: UsersChartDrill): string {
  if (!d) return 'noudrill';
  if (d.kind === 'week') return `uw:${d.weekStart}`;
  if (d.kind === 'activityType') return `uat:${d.activityType}`;
  return `uc:${d.customerId}`;
}
